// extracted by mini-css-extract-plugin
export var brandLockup = "_ir-5";
export var brandLogo = "_ir-6";
export var bullet = "_ir-1i";
export var bulletText = "_ir-1h";
export var bullets = "_ir-1c";
export var callout = "_ir-12";
export var calloutBody = "_ir-14";
export var calloutLabel = "_ir-13";
export var checkIcon = "_ir-1e";
export var checkList = "_ir-1b";
export var checkSvg = "_ir-1f";
export var checkText = "_ir-1g";
export var choiceCard = "_ir-x";
export var choiceDescription = "_ir-10";
export var choiceIcon = "_ir-11";
export var choiceText = "_ir-y";
export var choiceTitle = "_ir-z";
export var closeButton = "_ir-d";
export var codeText = "_ir-28";
export var compactPage = "_ir-f";
export var content = "_ir-9";
export var contentColumn = "_ir-3";
export var coverageCard = "_ir-o";
export var coverageDescription = "_ir-24";
export var coverageTitle = "_ir-23";
export var eyebrow = "_ir-i";
export var fieldCard = "_ir-m";
export var fieldDescription = "_ir-r";
export var fieldError = "_ir-s";
export var fieldHeader = "_ir-p";
export var fieldTitle = "_ir-q";
export var finalNote = "_ir-29";
export var footer = "_ir-a";
export var fulfillmentBody = "_ir-1u";
export var fulfillmentBodyText = "_ir-1v";
export var fulfillmentRow = "_ir-1r";
export var fulfillmentRows = "_ir-1q";
export var fulfillmentTitle = "_ir-1t";
export var header = "_ir-4";
export var heading = "_ir-h";
export var helperText = "_ir-1k";
export var indented = "_ir-1x";
export var inlineLink = "_ir-26";
export var inlineTitle = "_ir-2a";
export var intro = "_ir-k";
export var linkPreview = "_ir-1z";
export var listItem = "_ir-1d";
export var main = "_ir-1";
export var marketingImage = "_ir-c";
export var marketingPanel = "_ir-b";
export var modal = "_ir-0";
export var noteBody = "_ir-v";
export var noteBodyText = "_ir-w";
export var noteCard = "_ir-n";
export var noteIcon = "_ir-t";
export var noteTitle = "_ir-u";
export var numberBadge = "_ir-2e";
export var numberedStep = "_ir-2c";
export var numberedStepBody = "_ir-2f";
export var numberedStepCta = "_ir-2d";
export var numberedStepDescription = "_ir-2h";
export var numberedStepTitle = "_ir-2g";
export var numberedSteps = "_ir-2b";
export var page = "_ir-e";
export var playCircle = "_ir-18";
export var playIcon = "_ir-19";
export var policyBody = "_ir-21";
export var policyHeader = "_ir-20";
export var policyPreview = "_ir-1y";
export var policyTitle = "_ir-22";
export var progressFill = "_ir-8";
export var progressTrack = "_ir-7";
export var pseudoLink = "_ir-25";
export var pseudoLinkIcon = "_ir-27";
export var rowHeader = "_ir-1s";
export var section = "_ir-g";
export var shell = "_ir-2";
export var statusIconSuccess = "_ir-1m";
export var statusIconSvg = "_ir-1o";
export var statusIconWarning = "_ir-1n";
export var statusRow = "_ir-1l";
export var statusText = "_ir-1p";
export var stepTitle = "_ir-j";
export var strongText = "_ir-1w";
export var subHeading = "_ir-l";
export var videoEmbed = "_ir-16";
export var videoIframe = "_ir-17";
export var videoLabel = "_ir-1a";
export var videoPlaceholder = "_ir-15";
export var warningIcon = "_ir-1j";